/**
 * Project Service for DealRoom Projects
 */

import { apiService, ProjectItem, ProjectsResponse } from "./api";

class ProjectService {
	private baseUrl = `${apiService.getBaseUrlForVersion("v3")}/projects`;

	/**
	 * List all projects for the current client
	 */
	async listProjects(limit = 50, offset = 0): Promise<ProjectsResponse> {
		const params = new URLSearchParams({
			limit: String(limit),
			offset: String(offset),
		});
		console.log(`[ProjectService] Fetching projects from ${this.baseUrl}`);
		return await apiService.get<ProjectsResponse>(`${this.baseUrl}?${params}`);
	}

	/**
	 * Get a specific project by ID
	 */
	async getProject(projectId: string): Promise<ProjectItem> {
		return await apiService.get<ProjectItem>(`${this.baseUrl}/${projectId}`);
	}

	/**
	 * Create a new project
	 */
	async createProject(data: {
		name?: string;
		description?: string;
	}): Promise<ProjectItem> {
		return await apiService.post<ProjectItem>(this.baseUrl, data, {
			"Content-Type": "application/json",
		});
	}

	/**
	 * Create a new project with folder (returns project_id and folder_id)
	 */
	async createProjectWithFolder(data: {
		name?: string;
		description?: string;
	}): Promise<{
		project_id: string;
		folder_id: number;
		project_name: string;
		folder_name: string;
		folder_path: string;
	}> {
		return await apiService.post(
			`${this.baseUrl}/create-with-folder`,
			data,
			{
				"Content-Type": "application/json",
			},
		);
	}
}

export const projectService = new ProjectService();
export default projectService;
